<template>
  <div class="portal-products">
    <h3>Your Cart</h3>
    <div class="portal-product" v-for="(item, index) in items" :key="index">
      <div
        class="portal-product-image"
        :class="`${
                    item.product.id === '642edd7e-d3cf-4a7a-9e9a-db683a7a0b39' ||
                    item.product.id === '009cad7b-08a1-4de9-afbc-b30f7c824d7d' ||
                    item.product.id === 'b16fa3da-48ad-470e-8d9c-4f592a2b5765' ||
                    item.product.id === '74536e54-1207-45b6-a889-3c1776787ef7' ||
                    item.product.id === 'a3fb0ef6-0225-4b1b-ac0f-2b25576e8419'
                ? 'no--paddings' : ''}`"
      >
        <img
          v-if="
                    item.product.id === '642edd7e-d3cf-4a7a-9e9a-db683a7a0b39' ||
                    item.product.id === '009cad7b-08a1-4de9-afbc-b30f7c824d7d' ||
                    item.product.id === 'b16fa3da-48ad-470e-8d9c-4f592a2b5765' ||
                    item.product.id === '74536e54-1207-45b6-a889-3c1776787ef7' ||
                    item.product.id === 'a3fb0ef6-0225-4b1b-ac0f-2b25576e8419'
                    "
          :src="getImageUrl(item.product.thumbnail)"
          :alt="item.product.name"
        >
        <img
          v-else
          :src="item.product.thumbnail"
          :alt="item.product.name"
        >
      </div>
      <div
        class="portal-product-video"
        v-if="
                item.product.id === '642edd7e-d3cf-4a7a-9e9a-db683a7a0b39' ||
                item.product.id === '009cad7b-08a1-4de9-afbc-b30f7c824d7d' ||
                item.product.id === 'b16fa3da-48ad-470e-8d9c-4f592a2b5765' ||
                item.product.id === '74536e54-1207-45b6-a889-3c1776787ef7' ||
                item.product.id === 'a3fb0ef6-0225-4b1b-ac0f-2b25576e8419'
                "
      >
        <video width="100%" muted autoplay loop>
          <source :src="`/video/${getVideoUrl(item.product.thumbnail)}`" type="video/mp4">
          Your browser does not support HTML video.
        </video>
      </div>
      <div class="portal-product-info--wrapper">
        <div class="portal-product-info">
                    <span class="portal-product-text">
                        {{ item.product.name.split(' ')[0] }}
                    </span>
          <span v-if="isFromUpsell && !hadWeightConsultation">
                    <span v-if="item.price != item.product.price">
                      <s>{{ item.product.price | currency }}</s><br />
                    </span>
                    {{ getUpsellPagePrice(item.product.type.name) | currency }}
                  </span>
          <span v-else-if="localFromPromo49Page">$0</span>
          <span v-else-if="localFromPromo99Page">${{ getProductPrice }}</span>
          <span v-else-if="isFromUpsell && hadWeightConsultation">${{ getPriceForItem(item) | currency }}</span>
          <span v-else-if="hasDiscountedPrice">${{ hasDiscountedPrice }}</span>
          <span v-else-if="hasWlRenewalPrice">${{ hasWlRenewalPrice }}</span>
          <span v-else>
                    <span v-if="getDisplayPriceForItem(item) != item.product.price">
                      <s>{{ item.product.price | currency }}</s><br />
                    </span>
                    {{ getDisplayPriceForItem(item) | currency }}
                  </span>
        </div>

        <div v-if="localFromPromo49Page">
          <span>Lowest price of any US company!</span>
          <div style="margin-block: 0.5rem">
            <small>Your promo code has been successfully applied! You will only be charged for shipping.
              Refills are {{ getItemRefillPrice(item.product.type.name)|currency }} and include 24 Hour Shipping - the lowest price
              of any US telehealth company (even as strength increases, the price does not increase).</small>
          </div>
        </div>

        <div v-else-if="localFromPromo99Page">
          <div style="margin-block: 0.5rem">
            <small>Your promo code has been successfully applied!
              Future refills are {{ getItemRefillPrice(item.product.type.name)|currency }} and include
              24 Hour Shipping - the lowest price of any US telehealth company
              (even as strength increases, the price does not increase).</small>
          </div>
        </div>

        <div v-else-if="hasDiscountedPrice">
          <span>Lowest price of any US company!</span>
          <div style="margin-block: 0.5rem">
            <small>
              The promo code has been successfully applied for your 1st order. Refills are at {{ getItemRefillPrice(item.product.type.name)|currency }} – the lowest price of any US telehealth company.
            </small>
          </div>
        </div>

        <div v-else-if="isFromUpsell">
          <span>Lowest price of any US company!</span>
          <div style="margin-block: 0.5rem">
            <small>
              The promo code has been successfully applied for your 1st order. Refills are at {{ getItemRefillPrice(item.product.type.name)|currency }} – the lowest price of any US telehealth company.
            </small>
          </div>

        </div>
        <div v-if="latestNonWeightLossProduct && showMessage" class="billing-product-message-alert">
          Your first order for {{ latestNonWeightLossProduct.split(' ')[0] }} has been successfully submitted. <br /> This is your second order.
        </div>
        <a class="cart-action--light" :href="`/cart/items/${item.rowId}`">
          <span class="remove"></span>
          Remove {{ item.name.split(' ')[0] }}
        </a>
      </div><!-- .portal-product-info--wrapper -->
    </div><!-- .portal-product -->
    <span class="portal-product-text" v-if="!localFromPromo49Page"><small>24 Hour Shipping (always included)</small></span>
    <span class="portal-product-text" v-else><small>49.00 shipping/handling (as free product orders do not include 24 Hour Shipping)</small></span>
    <template v-if="couponCode">
      <div class="portal-product-info portal-product-info--sub">
        <span class="portal-product-text">Subtotal:</span>
        <span class="portal-product-text">{{ subtotal|currency }}</span>
      </div>
      <div class="portal-product-info portal-product-info--sub">
        <span class="portal-product-text">Discount/Voucher Code:</span>
        <span class="portal-product-text">{{ couponCode }}</span>
      </div>
      <div class="portal-product-info portal-product-info--final">
        <span class="portal-product-text">Total: <span class="note" v-if="firstShipmentNote">{{ firstShipmentNote }}</span></span>
        <span class="portal-product-text">{{ firstShipmentTotal|currency }}</span>
      </div>
    </template>
    <template v-else>
      <div class="portal-product-info portal-product-info--final">
            <span class="portal-product-text">
              Total: <span class="note" v-if="firstShipmentNote">{{ firstShipmentNote }}</span>
            </span>
        <span class="portal-product-text" v-if="isFromUpsell && !hadWeightConsultation">
              {{ getUpsellPagePrice(items[0].product.type.name) | currency }}
            </span>
        <span class="portal-product-text" v-else-if="localFromPromo49Page || localFromPromo99Page">
              ${{ getProductPrice }}
            </span>
        <span class="portal-product-text" v-else-if="isFromUpsell && hadWeightConsultation">{{ firstProductPrice | currency }}</span>
        <span class="portal-product-text" v-else-if="hasDiscountedPrice">{{ hasDiscountedPrice | currency }}</span>
        <span class="portal-product-text" v-else-if="hasWlRenewalPrice">{{ hasWlRenewalPrice | currency }}</span>
        <span class="portal-product-text" v-else>
              {{ firstProductPrice | currency }}
            </span>
      </div>
    </template>
  </div><!-- portal-products -->
</template>
<script>
import { EventBus } from './event-bus.js';
import axios from 'axios';
export default {
  props: {
    // items: {},
    initialCouponCode: {},
    unlimitedCouponCode: {
      type: Boolean
    },
    latestNonWeightLossProduct: {
      type: String
    },
    showMessage: {
      type: Boolean
    },
    fromPromo49Page: {
      type: Boolean
    },
    fromPromo99Page: {
      type: Boolean
    }
  },
  data() {
    return {
      couponCode: null,
      cart: null,
      isLoadingCart: false,
      hadWeightConsultation: true,
      localFromPromo49Page: this.fromPromo49Page,
      localFromPromo99Page: this.fromPromo99Page,
    }
  },
  filters: {
    currency(value) {
      return '$'+parseFloat(value).toFixed(2);
    }
  },
  watch: {
  },
  computed: {
    getVideoUrl() {
      return (url) => {
        let vidUrl = url.split('/images/thumbnails/').join('')
        vidUrl = vidUrl.split('.jpg').join('.mp4')
        return vidUrl
      }
    },
    getImageUrl() {
      return (url) => {
        let imageUrl = url.split('.jpg').join('.png')
        return imageUrl
      }
    },
    items() {
      return this.cart ? [this.cart.items[0]] : []
    },
    subtotal() {
      if (this.hasWlRenewalPrice) {
        return parseFloat(this.hasWlRenewalPrice);
      }

      let subtotal = 0;
      this.items.forEach((item) => {
        subtotal += this.getPriceForItem(item)
      });
      return subtotal;
    },
    firstShipmentTotal() {
      if (this.hasWlRenewalPrice) {
        return parseFloat(this.hasWlRenewalPrice);
      }

      let subtotal = 0;
      this.items.forEach((item) => {
        subtotal += this.getFirstShipmentPriceForItem(item)
      });
      return subtotal;
    },
    firstShipmentNote() {
      if (this.firstShipmentTotal === 0) {
        if (this.unlimitedCouponCode) {
          return '(First shipment is FREE!)'
        }
        return '(First shipment is pre-paid)'
      }
      return ''
    },
    cartQueryString() {
      if (this.couponCode) {
        return `?couponCode=${this.couponCode}`
      }
      return ''
    },
    isFromUpsell() {
      return localStorage.getItem('fromUpsellPage') === 'true';
    },
    hasDiscountedPrice() {
      if (localStorage.getItem('discountedPrice')) {
        return localStorage.getItem('discountedPrice');
      } else {
        return false;
      }
    },
    hasWlRenewalPrice() {
      if (localStorage.getItem('fromWlRenewalLink') !== 'true') {
        return false;
      }

      const renewalPrice = localStorage.getItem('wlRenewalPrice');
      return renewalPrice ? renewalPrice : false;
    },
    getProductPrice() {
      if (this.localFromPromo49Page) {
        return 49;
      }
      if (this.localFromPromo99Page) {
        return 99;
      }
      return this.subtotal;
    },
    firstProductPrice() {
      if (this.hasWlRenewalPrice) {
        return parseFloat(this.hasWlRenewalPrice);
      }

      if (this.items && this.items.length > 0) {
        return this.getPriceForItem(this.items[0]);
      }

      return 0;
    }

  },
  mounted() {
    this.fetchWeightConsultation();
    if (this.initialCouponCode) {
      this.couponCode = this.initialCouponCode;
    }
    EventBus.$on('validatedCode', couponCode => {
      this.couponCode = couponCode;
      this.retrieveCurrentOrder()
    });
    EventBus.$on('removedCode', () => {
      this.couponCode = null;
      this.retrieveCurrentOrder()
    });
    this.retrieveCurrentOrder();
    this.showMessage = localStorage.getItem('showOrderMessage') === 'true'
    localStorage.removeItem('showOrderMessage')
    this.localFromPromo49Page = localStorage.getItem('fromPromo49Page') === 'true'
    this.localFromPromo99Page = localStorage.getItem('fromPromo99Page') === 'true'
  },
  methods: {
    isZoomThumbnail(thumbnail) {
      return (
        thumbnail === '/images/weight-loss/Semaglutide_Plus.webp' ||
        thumbnail === '/images/weight-loss/Tirzepatide_Plus.webp'
      );
    },
    getPriceForItem(item) {
      if (this.hasWlRenewalPrice && this.itemMatchesRenewalProduct(item)) {
        return parseFloat(this.hasWlRenewalPrice);
      }

      return item.price;
    },
    getFirstShipmentPriceForItem(item) {
      return item.firstShipmentPrice !== null && item.firstShipmentPrice !== undefined
        ? item.firstShipmentPrice
        : item.price;
    },
    getDisplayPriceForItem(item) {
      if (this.couponCode) {
        return this.getFirstShipmentPriceForItem(item);
      }
      return this.getPriceForItem(item);
    },
    retrieveCurrentOrder() {
      if (this.isLoadingCart) {
        return;
      }

      this.isLoadingCart = true;

      axios.get(`/api/v1/cart${this.cartQueryString}`)
        .then((response) => {
          if (response.data.data) {
            this.cart = response.data.data
          }
        })
        .catch(function (error) {
        })
        .finally(() => {
          this.isLoadingCart = false;
        })
    },
    fetchWeightConsultation() {
      axios.get(`/api/v1/hadEverWeightConsultation`)
        .then((response) => {
          this.hadWeightConsultation = response.data === true || response.data === 'true';
        })
        .catch((e) => {
          this.hadWeightConsultation = true;
        })
      localStorage.setItem('hadWeightConsultation', this.hadWeightConsultation)
    },
    getItemRefillPrice(name) {
      const isTirzepatide = name === 'Tirzepatide';

      // Effective upsell only (matches billing): 119 / 149
      if (this.isFromUpsell && !this.hadWeightConsultation) {
        return isTirzepatide ? 149 : 119;
      }

      // Promo49 / Promo99 subsequent display: 169 / 199
      if (this.localFromPromo49Page || this.localFromPromo99Page) {
        return isTirzepatide ? 199 : 169;
      }

      // Best-seller, first-order, and catalog default refill: 159 / 199
      return isTirzepatide ? 199 : 159;
    },
    getUpsellPagePrice(name) {
      if (name === 'Tirzepatide') {
        return 89;
      }
      return 59;
    },
    itemMatchesRenewalProduct(item) {
      const renewalProductKey = localStorage.getItem('wlRenewalProductKey');
      if (!renewalProductKey || !item || !item.product || !item.product.type) {
        return true;
      }

      const typeName = (item.product.type.name || '').toLowerCase();
      if (renewalProductKey === 'tirzepatide') {
        return typeName.indexOf('tirzepatide') !== -1;
      }

      return typeName.indexOf('semaglutide') !== -1;
    }
  }
}
</script>

<style lang="scss">
.billing-product-message-alert {
    background-color: #009966;
    color: white;
    text-align: center;
    padding: 0.25rem 1rem;
    border-radius: 4rem;
    font-size: 0.8rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/WeightProducts.vue